(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/views/lotto-rule-change-info.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/views/lotto-rule-change-info.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lotto=_svs.lotto||{};
_svs.lotto.components=_svs.lotto.components||{};
_svs.lotto.components.play=_svs.lotto.components.play||{};
_svs.lotto.components.play.templates=_svs.lotto.components.play.templates||{};
svs.lotto.components.play.templates.lotto_rule_change_info = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "      Nu fler miljonvinster och fler vinstchanser på Lotto! För att göra detta möjligt har radpriset höjts med 1&nbsp;kr.\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "      Fler miljonvinster och fler vinstchanser från och med september. För att göra detta möjligt höjs radpriset med 1&nbsp;kr. \n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"lotto-rule-change-info-container u-border-radius-6 padding-2 bg-tur-100 margin-top-1 margin-bottom-2\">\n  <p>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isNewRules") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":7,"column":11}}})) != null ? stack1 : "")
    + "    <a id=\"show-fullscreen-info\" aria-label=\"Läs mer om ändringarna\">Läs mer om ändringarna</a>\n  </p>\n</div>\n<div class=\"lotto-fullscreen-container\" id=\"lotto-fullscreen-container\"></div>";
},"useData":true});
Handlebars.partials['svs-lotto-components-play-lotto_rule_change_info'] = svs.lotto.components.play.templates.lotto_rule_change_info;
})(svs, Handlebars);


 })(window);